define('ordersDetailSupplierEditProductInfosView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'ordersDetailSupplierEditProductInfosOptionsView',
  'template!ordersDetailSupplierEditProductInfosView',
  'entities/product'
], function (
  App,
  module,
  Marionette,
  _,
  OptionsView,
  Tpl
) {
  'use strict';

  module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'infos-view',

    regions: {
        optionsRegion: '.options-region'
    },

    serializeData: function() {
      var data = {};

      var product = this.model.get('products')[0];

      data.name = '-';
      if(this.options.product.get('name'))
        data.name = this.options.product.get('name');

      data.code = '-';
      if(product.productCode)
        data.code = product.productCode;

      data.quantity = '-';
      if(this.model.get('exactQuantity'))
        data.quantity = this.model.get('exactQuantity') + ' ' + _.i18n('common.pcs');

      return data;
    },

    onShow: function () {
      this.optionsView = new OptionsView({
        model: this.model,
        product: this.options.product
      });
      this.getRegion('optionsRegion').show(this.optionsView);
    }
  });
});
